import { useCallback, useMemo } from "react";
import Questionnaires from "./questionnaires";
import { getAiActQuestionnaireSlug } from "./questionnaires/helpers/getAiActQuestionnaireSlug";
import { mergeComplianceObligations } from "src/modules/data-protection/helpers/complianceObligations";
import { isFeatureEnabledForActiveModule } from "src/helpers/module_helper";

const AIGovernanceAssessments = (props) => {
    const {
        softwareData,
        refetchSoftwareData,
        activeAssessment,
        onProgressChange,
        onAssessmentSaved
    } = props;

    const isCeConformityEnabled = isFeatureEnabledForActiveModule("ce-conformity");

    const complianceObligations = useMemo(() => {
        if (!softwareData) {
            return [];
        }

        // Merge AI Risk Assessment and CE Conformity obligation sources.
        // Unknown / future arrays are ignored safely when absent.
        return mergeComplianceObligations(
            softwareData.ai_act_obligations,
            isCeConformityEnabled ? softwareData.conformity_obligations : []
        );
    }, [softwareData, isCeConformityEnabled]);

    const onValidSubmit = useCallback(() => {
        // Obligations and completion flags live on the asset data owned by the
        // details page.
        refetchSoftwareData && refetchSoftwareData();

        onAssessmentSaved && onAssessmentSaved();
    }, [onAssessmentSaved, refetchSoftwareData]);

    return (
        <>
            {softwareData && (
                <Questionnaires
                    onValidSubmit={onValidSubmit}
                    refetchSoftwareData={refetchSoftwareData}
                    refetchAssessmentCards={onAssessmentSaved}
                    aiRiskAssessmentId={softwareData.ai_risk_assessment_report_id}
                    aiActQuestionnaireSlug={getAiActQuestionnaireSlug(
                        softwareData.ai_setup_mode
                    )}
                    enableQuestionnaire={softwareData.has_ai_risk_assessment}
                    filledWithAIBefore={false}
                    isQuestionnaireCompleted={softwareData.ai_act_questionnaire_filled}
                    friaOptions={{
                        friaRequired: softwareData.fria_required,
                        hasFriaAssessment: softwareData.has_fria_assessment,
                        friaStatus: softwareData.fria_status,
                        friaReportCaseId: softwareData.fria_assessment_report_id
                    }}
                    conformityOptions={{
                        providerConformityRequired: isCeConformityEnabled && softwareData.provider_conformity_required,
                        providerConformityStatus: softwareData.provider_conformity_status,
                        conformityReportCaseId: softwareData.conformity_assessment_report_id
                    }}
                    providerConformityRequired={isCeConformityEnabled && softwareData.provider_conformity_required}
                    complianceObligations={complianceObligations}
                    activeAssessment={activeAssessment}
                    onProgressChange={onProgressChange}
                />
            )}
        </>
    );
};

export default AIGovernanceAssessments;
